module.exports = __webpack_public_path__ + "img/arrow.b4ff81dd.svg";